import { Lock } from "@mui/icons-material";
import { Box, Typography, styled } from "@mui/material";
import { ReactNode } from "react";
import { fadedPrimaryBg } from "./WooCommerceOnboardingPlatformLogoBox";

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[50],
}));

const IconWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 36,
  height: 36,
  borderRadius: "50%",
  backgroundColor: fadedPrimaryBg(theme),
  color: theme.palette.primary.main,
  flexShrink: 0,
}));

interface IWooCommerceOnboardingSecurityNoteProps {
  children: ReactNode;
}

function WooCommerceOnboardingSecurityNote({
  children,
}: IWooCommerceOnboardingSecurityNoteProps) {
  return (
    <Root>
      <IconWrap>
        <Lock fontSize="small" />
      </IconWrap>
      <Typography variant="body2" color="text.secondary" component="div">
        {children}
      </Typography>
    </Root>
  );
}

export default WooCommerceOnboardingSecurityNote;
